// @ts-nocheck
import React from "react";
import { UserIcon } from "../../../../resources/icons/header";
import clsx from "clsx";

interface Props {
  className?: string;
  image?: string | null;
  classNameImage?: string;
}
export const BaseUserIconComponent = (props: Props) => {
  const { image, className, classNameImage } = props;

  const baseStyle = "flex justify-center items-center bg-active-light relative";
  return (
    <>
      {image ? (
        <div
          className={clsx(
            baseStyle,
            className ? className : "w-10 h-10 rounded-full ",
          )}
        >
          <img
            src={image}
            className={clsx(
              classNameImage
                ? classNameImage
                : "panel-element justify-center items-center user-img  w-10 h-10 rounded-full",
            )}
            alt={"userIcon"}
          />
        </div>
      ) : (
        <div
          className={clsx(
            baseStyle,
            className
              ? className
              : "min-w-10 h-10 rounded-full  border-[0.2px] border-white",
          )}
        >
          <UserIcon
            className={clsx(classNameImage ? classNameImage : "w-4 h-5")}
          />
        </div>
      )}
    </>
  );
};
